import angular from 'angular'
import dsStudentInfoOverviewController from './student-info-overview.controller'
import dsStudentInfoOverview from './student-info-overview.directive'
import { telFormat } from './../../../filters/telFormat';

export default angular.module( 'directives.studentinfooverview', [] )
    .controller( 'dsStudentInfoOverviewController', dsStudentInfoOverviewController )
    .directive( 'dsStudentInfoOverview', dsStudentInfoOverview )
    .filter('telFormat', telFormat);
